////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Primary site navigation — shared by the header and MenuOverlay  //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { NavLink } from 'react-router';

// MARK — order/labels taken from the old site's menu_position frontmatter (home 1,
// about 2, news-updates 5, contact 6) with Projects/Careers slotted in at their old
// site position (3/4); those two pages were deliberately not scraped for content
// (API-driven, per 1.0.0.md) so there is no frontmatter to confirm the exact
// position against. Flagging for ratification rather than guessing wrong silently.
// Exported — components/chrome/MenuDropdown.tsx (1.0.3) reuses this same list to
// build its staggered items rather than hand-duplicating the order/labels.
export const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/projects', label: 'Projects' },
  { to: '/careers', label: 'Careers' },
  { to: '/news', label: 'News' },
  { to: '/contact', label: 'Contact' },
];

export interface NavProps {
  /** Called on link activation — MenuOverlay uses this to close itself; the
   * header's persistent nav passes nothing. */
  onNavigate?: () => void;
  orientation?: 'horizontal' | 'vertical';
}

export function Nav ({ onNavigate, orientation = 'horizontal' }: NavProps) {
  return (
    <nav aria-label="Primary">
      <ul
        className={
          orientation === 'horizontal'
            ? 'flex items-center gap-8'
            : 'flex flex-col gap-6 text-2xl'
        }
      >
        {NAV_ITEMS.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              onClick={onNavigate}
              className={({ isActive }) =>
                isActive ? 'font-semibold text-ink' : 'text-ink/80 hover:text-ink'
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
